interface AppendSignatureRequest {
  tx_cbor: string;
  signed_witness_set: string;
}

interface AppendSignatureResponse {
  tx_cbor: string;
}

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

/**
 * Send the signed witness set to the backend to append to the transaction.
 * 
 * @param unsignedTxCbor - The unsigned transaction CBOR from create-fund
 * @param witnessSetCbor - The signed witness set CBOR from wallet.signTx()
 * @returns The fully signed transaction CBOR
 */
export const appendSignature = async (
  unsignedTxCbor: string,
  witnessSetCbor: string
): Promise<string> => {
  try {
    const body: AppendSignatureRequest = {
      tx_cbor: unsignedTxCbor,
      signed_witness_set: witnessSetCbor,
    };

    console.log("Sending to append-signature:", {
      tx_cbor_length: unsignedTxCbor.length,
      witness_set_length: witnessSetCbor.length,
    });

    const res = await fetch(`${API_URL}/append-signature`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error("Append signature error response:", errorText);
      throw new Error(`Backend error: ${res.status} ${res.statusText} - ${errorText}`);
    }

    const data: AppendSignatureResponse = await res.json();
    console.log("Received signed transaction, length:", data.tx_cbor.length);
    return data.tx_cbor;
  } catch (e) {
    console.error("API appendSignature ERROR::", e);
    throw e;
  }
};
